import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
  ],
});

export const styles = StyleSheet.create({
  page: {
  position: 'relative',
  flexDirection: 'row',
  fontFamily: 'Lato',
  paddingHorizontal: 20,
  paddingTop: 20,
  width: '100%',
  height: '100%',
},
leftColumn: {
  width: '50%',
  flexDirection: 'row',
  flexWrap: 'nowrap',
  gap: "2.5rem", 
},
imageColumnWrapper: {
  position: 'absolute',
  flexDirection: 'column',
  gap: 15,
  top: 0,
  left: 0,
},
imageClip: {
  width: 190,
  height: 215,
  overflow: 'hidden',
},
image: {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  borderRadius: 5,
},
rightColumn: {
  width: '50%',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  paddingLeft: 20,
  paddingTop: 180,
},
eventImage: {
  height: 240, 
  objectFit: 'contain',
  paddingLeft: 10,
},
textWrapper: {
  width: '100%',
  height: '100%',
  paddingLeft: 20,
},
title: {
  color: 'black',
  fontFamily: 'Lato',
  fontSize: 20, 
  fontWeight: 400,
  textAlign: 'left',
  marginTop: 20,
  width: '100%',
},
subtitle: {
  color: '#27343d',
  fontFamily: 'Lato',
  fontSize: 10, 
  fontWeight: 400,
  textAlign: 'left',
  marginTop: 20,
},
});
